<template>
  <div class="yt-group-list">
    <GridTable
      v-if="stateFilterBySchool"
      ref="gridTable"
      id="GroupList"
      :key="componentKey"
      :title="`${title}${appendTitle || ''}`"
      urlPath="groupsCms"
      :columns="columns"
      :schema="schema"
      :defaultServerParams="{
        _fields: '_id,name,school._id,school.name,isActive',
        schoolId: filteredBySchool
      }"
      @setModeSchema="onSetModeSchema"
    />
  </div>
</template>

<script>
import { Component } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import VueFormGenerator from 'vue-form-generator'

import BaseList from '@/components/BaseList'

const appModule = namespace('app')

@Component()
export default class GroupList extends BaseList {
  @appModule.State('schools') stateSchools
  @appModule.State('filterBySchool') stateFilterBySchool

  title = 'Subjects'

  columns = [
    {
      label: 'ID',
      field: '_id',
      hidden: true
    },
    {
      label: 'Name',
      field: 'name',
      filterOptions: {
        enabled: true, // enable filter for this column
        placeholder: 'Filter by Name', // placeholder for filter input
        filterValue: '', // initial populated value for this filter
        trigger: 'keyup' // only trigger on enter not on keyup
      }
    },
    {
      label: 'School',
      field: 'school.name',
      filterOptions: {
        enabled: true, // enable filter for this column
        placeholder: 'Filter by School', // placeholder for filter input
        filterValue: '', // initial populated value for this filter
        filterDropdownItems: [], // dropdown (with selected values) instead of text input
        isMultiselect: true,
        fieldNameFilter: 'schoolId'
        // filterFn: this.columnFilterFn, // custom filter function that
        // trigger: 'keyup' // only trigger on enter not on keyup
      }
    },
    {
      label: 'Active',
      field: 'isActive',
      type: 'switch'
    },
    {
      label: 'Actions',
      field: 'actions'
    }
  ]

  schema = {
    fields: [
      {
        // label: 'ID (disabled text field)',
        model: '_id',
        type: 'input',
        inputType: 'hidden',
        readonly: true
        // disabled: true
      },
      {
        label: 'Name',
        model: 'name',
        type: 'input',
        inputType: 'text',
        placeholder: 'Group name',
        required: true,
        validator: ['string']
      },
      {
        label: 'School',
        model: 'schoolId',
        type: 'select',
        featured: true,
        required: true,
        validator: VueFormGenerator.validators.required.locale({
          fieldIsRequired: 'School is required!'
        })
        // disabled: true
      },
      {
        label: 'Active',
        model: 'isActive',
        type: 'switch',
        default: false,
        textOn: 'Active',
        textOff: 'Inactive'
      }
    ]
  }

  onSetModeSchema(mode) {
    if (mode === 'update') {
      const refGridTable = this.$refs.gridTable

      const school = refGridTable.getFieldDataSelectedRow('school')
      if (typeof school === 'object' && school.hasOwnProperty('_id')) {
        refGridTable.setFieldDataSelectedRow('schoolId', school._id)
      }
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/subjects/GroupList.vue